import { addQuerys, AppError } from "./utils";
import { Toast } from "antd-mobile";

export default async function request(method, url, params, config) {

  let serverAPIPrefix = process.env.REACT_APP_API_URL

  if (url.startsWith("/")) {
    url = serverAPIPrefix + url;
  }

  const options = {
    method,
    credentials: "include",
  };

  if (method === "GET") {
    url = addQuerys(url, params);
  } else {
    options.body = JSON.stringify(params || {});
    options.headers = {
      "Content-Type": "application/json",
    };
  }

  const res = await fetch(url, {
    ...options,
    ...config,
  });

  if (res.status >= 200 && res.status < 300) {
    return res.json();
  }

  const resBody = await res.text();

  throw new AppError(res.status === 477 ? resBody : "");
}
